export default class LinkCell extends HTMLElement {
  constructor(link = '', clickFunc = () => window.open(link)) {
    super();
    let container = document.createElement('div');

    container.innerHTML += link;
    if(link && link.trim().toUpperCase() != "N/D" && link.trim().toUpperCase() != "-" ){
      container.style.textDecoration = 'underline';
      container.style.color = '#278BD8';
      container.onclick = () => {
        clickFunc()
      };
    }

    this.append(container);
  }
}

customElements.define('link-cell', LinkCell)
